<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_updateActionAllowed"
            :title="'Přidat okno údržby ke zdroji obsahu' | translate"
            route-name="contentSourceMaintenanceWindowNew">
        </add-button>
        <h1 v-translate>Údržba zdrojů obsahu</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="table_overflow">
            <table class="vypis vypis_detail" ref="table_with_action_line" v-show="dataLoaded">
            <thead>
            <tr>
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sortable="title.sortable"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <content-source-maintenance-window-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                ref="content_source_maintenance_window_row"
                @input="select"
                @updateEntity="updateEntity"
                @deleteEntity="deleteEntity"
            ></content-source-maintenance-window-row>
            </tbody>
          </table>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="filteredSelectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import ContentSourceMaintenanceWindowRow from "./ContentSourceMaintenanceWindowRow.vue";
import listActions from "@/components/mixins/list-actions"
import ContentSourceMaintenanceWindowService from "../../../service/ContentSourceMaintenaceWindowService";

export default {
  name: "ContentSourceMaintenceWindowList",
  components: {ContentSourceMaintenanceWindowRow},
  mixins: [listActions],
  data() {
    return {
      moduleName: 'contentSourceMaintenanceWindows',
      entitiesKey: 'content_source_maintenance_window',
      formFields: {
        sort: {
          column: 'sHostname',
          direction: 'asc'
        },
      },
    }
  },
  created(ContentSourceMaintenanceWindowService) {
    this.entityService = ContentSourceMaintenanceWindowService

    this.createdInit()
  },
  computed: {
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    sortingTableTitles() {
      return [
        {id: 1, name: this.$gettext('Název zdroje obsahu'), column: 'sHostname'},
        {id: 2, name: this.$gettext('Začátek údržby'), column: 'sStart'},
        {id: 3, name: this.$gettext('Konec údržby'), column: 'sEnd'},
        {id: 4, name: this.$gettext('Popis'), column: 'sDescription', sortable: false},
        {id: 5, name: this.$gettext('Datum vytvoření'), column: 'sDateCreated'},
        {id: 6, name: this.$gettext('Datum editace'), column: 'sDateUpdated'},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers.from.callback = (entity) => {return entity.from ? this.$_datetime_format(entity.from) : ''};
      headers.to.callback = (entity) => {return entity.to ? this.$_datetime_format(entity.to) : ''};

      return headers;
    },
  },
  methods: {
    // loadAdditionalDefaults() {
    //   let anyChanges = false
    //   if (this.loadDefaultByKey('physical') && this.formFields.physical !== 0) {
    //     anyChanges = true
    //   }
    //   return anyChanges
    // },
    // saveFilterValues() {
    //   this.saveSearch(this.formFields.search)
    //   this.setUserSetting('physical', this.formFields.physical)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowLists.vue